import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SubstituteMaintenance } from "../../shared/data.service";
import { SubstituteDeleteRequest } from "../../shared/SubstituteDeleteRequest";
import { ModifySubstitutionComponent } from "./modify-substitution/modify-substitution.component";
import * as moment from "moment";

@Component({
	selector: "app-add-substitution-swap",
	templateUrl: "./add-substitution-swap.component.html",
	styleUrls: ["./add-substitution-swap.component.css"],
})
export class AddSubstitutionSwapComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		private SubstituteMaintenanceService: DataService_SubstituteMaintenance
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;

		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.PersonName = this.SelectedPerson.PersonName;
		this.PersonTypeDesc = this.SelectedPerson.PersonTypeDesc;

		this.School = this.dialogConfig.data.School;

		this.EndDate.setMonth(this.EndDate.getMonth() + 1);

		this.loadSubstitution();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	SelectedPerson: any;

	PersonName: any = "";
	PersonTypeDesc: any = "";

	School: any;
	StartDate: Date = new Date();
	EndDate: Date = new Date();

	AnyChanged: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSubstitution: any;
	lstSubstitution: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PersonName", header: "Subbing For" },
		{ field: "StartDateDesc", header: "Start Date" },
		{ field: "EndDateDesc", header: "End Date" },
		{ field: "CreatedBy", header: "Created By" },
		{ field: "Classes", header: "Classes" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSubstitution() {
		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;

		var result = this.SubstituteMaintenanceService.SubAssignTableSelectList(this.SelectedPerson.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstSubstitution = response;

				//Load Data Filter Lists

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSubstitution();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ModifySubstitutionComponent, {
			header: "Add Substitution",
			width: "fit-content",
			height: "500px",
			data: {
				//INSERT Custom Data here
				EditMode: false,
				user: this.user,
				SchoolID: this.School.SchoolID,
				PersonName: this.PersonName,
				Sub_PersonID: this.SelectedPerson.PersonID,
				SelectedSubstitution: null,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.AnyChanged = true;
				this.onRowUnselect(null);
				this.loadSubstitution();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedSubstitution == undefined) {
			this.errorMessage = "Select a substitution to edit";
			return;
		}

		var ref = this.dialogService.open(ModifySubstitutionComponent, {
			header: "Edit Substitution",
			width: "fit-content",
			height: "500px",
			data: {
				//INSERT Custom Data here
				EditMode: true,
				user: this.user,
				SchoolID: this.School.SchoolID,
				PersonName: this.PersonName,
				Sub_PersonID: this.SelectedPerson.Sub_PersonID,
				SelectedSubstitution: this.SelectedSubstitution,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.AnyChanged = true;
				this.onRowUnselect(null);
				this.loadSubstitution();
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		if (this.SelectedSubstitution == undefined) {
			this.errorMessage = "Select substitution to remove";
			return;
		}

		this.FinishRemove();

		//
		// Error Handling
		//
		// if(this.SelectedSubstitutions.length == 0){
		//   this.errorMessage = "Select substitutions to remove";
		//   return;
		// }

		// var MSG: any = "";

		// MSG = "You are about to remove " + this.SelectedSubstitutions.length + " substitution assignments. Do you want to continue?";

		// this.confirmationService.confirm(
		//   {
		//     key: "main",
		//     acceptLabel: "Yes",
		//     rejectLabel: "No",
		//     rejectVisible: true,
		//     message: MSG,
		//     header: "Confirm Delete Substitutions",
		//     icon: "fa",
		//     accept: () => {
		//       this.FinishRemove();
		//     },
		//     reject: () =>{
		//       return;
		//     }
		//   });
	}

	FinishRemove() {
		//
		// Create Request
		//

		let lstIDs: number[] = [];

		lstIDs = [...lstIDs, this.SelectedSubstitution.SubstitutionID];

		// for(var z = 0; z < this.SelectedSubstitutions.length; z++){
		//   var next = this.SelectedSubstitutions[z];

		//   lstIDs = [...lstIDs, next.SubstitutionID];
		// }

		let parms: SubstituteDeleteRequest = {
			lstSubstituteIDs: lstIDs,
		};

		var result = this.SubstituteMaintenanceService.SubstituteDeleteList(parms);
		result.subscribe(
			(response) => {
				this.AnyChanged = true;

				if (response) {
					this.loadSubstitution();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not remove substitution",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(this.AnyChanged == true ? 1 : 0);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadSubstitution();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadSubstitution();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSubstitution = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSubstitution = null;
	}
	onRowDblClick(Substitution) {
		this.SelectedSubstitution = Substitution;

		this.onEdit();
	}
	////////////////////////////////////////////
}
